import type { SongMeta } from '@/types';
import { generateChart } from '@/utils/chartGenerator';

const bpm = 120;
const duration = 46;

export const sunnyMeowSong: SongMeta = {
  id: 'sunny-meow',
  title: 'Sunny Meow',
  artist: 'Meow Melody Studio',
  bpm,
  duration,
  audio: 'synth',
  synthTrack: 'popLoop',
  difficulty: 2,
  background: 'sunsetHill',
  chart: generateChart({ bpm, durationSec: duration, stepBeats: 1, noteTravelTime: 1.9 }),
};
